import Zip from './Zip'

export default Zip
